<template>
  <div>
    <div v-for="(bulletin, i) in showBulletins" :key="i">
      <v-alert v-if="bulletin[$i18n.locale]" :value="true" :type="bulletin.alertType" outline
        v-html="bulletin[$i18n.locale]">
      </v-alert>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase/app';

export default {
  name: 'Bulletin',
  props: {
    licenses: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      allBulletins: [],
      showBulletins: [],
    };
  },
  mounted: async function () {
    const snap = await firebase
      .firestore()
      .collection('x_bulletins')
      .where('expired', '>', new Date())
      .orderBy('expired', 'asc')
      .get();
    for (const doc of snap.docs) {
      const data = doc.data();
      this.allBulletins.push(data);
    }
    this.refresh();
  },
  watch: {
    licenses: function () {
      this.refresh();
    },
  },
  methods: {
    refresh: function () {
      this.showBulletins.splice(0, this.showBulletins.length);
      for (const bulletin of this.allBulletins) {
        let show = false;
        if (bulletin.supportGame === '' || bulletin.supportGame === 'all') {
          show = true;
        } else {
          for (const licenseId in this.licenses) {
            if (this.licenses[licenseId].supportGame === bulletin.supportGame) {
              if (bulletin.taskConfig === null || bulletin.taskConfig === undefined) {
                show = true;
                break;
              }

              for (const t in this.licenses[licenseId].taskConfig) {
                if (
                  `${t}` in bulletin.taskConfig &&
                  this.licenses[licenseId].taskConfig[t] === bulletin.taskConfig[t]
                ) {
                  show = true;
                  break;
                }
              }
            }
          }
        } // if

        // Check userId
        if (bulletin.userId) {
          const currentUser = firebase.auth().currentUser;
          if (currentUser && currentUser.uid === bulletin.userId) {
            show = true;
          } else {
            show = false;
          }
        }

        // Check licenseId
        if (bulletin.licenseId) {
          if (bulletin.licenseId in this.licenses) {
            show = true;
          } else {
            show = false;
          }
        }

        if (show) {
          this.showBulletins.push(bulletin);
        }
      } // for
    },
  },
};
</script>